module.exports = __webpack_public_path__ + "static/media/6.5e0ad361.jpg";